var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseModal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M10.217 7.95023L16.3521 1.81497C16.7514 1.41589 16.7514 0.770645 16.3521 0.371571C15.953 -0.0275028 15.3078 -0.0275028 14.9087 0.371571L8.77343 6.50684L2.63835 0.371571C2.23909 -0.0275028 1.59403 -0.0275028 1.19495 0.371571C0.795693 0.770645 0.795693 1.41589 1.19495 1.81497L7.33004 7.95023L1.19495 14.0855C0.795693 14.4846 0.795693 15.1298 1.19495 15.5289C1.39384 15.728 1.65534 15.828 1.91665 15.828C2.17796 15.828 2.43928 15.728 2.63835 15.5289L8.77343 9.39363L14.9087 15.5289C15.1078 15.728 15.3691 15.828 15.6304 15.828C15.8917 15.828 16.153 15.728 16.3521 15.5289C16.7514 15.1298 16.7514 14.4846 16.3521 14.0855L10.217 7.95023Z",
    fill: "#35435E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseModal);
export default __webpack_public_path__ + "static/media/close-modal.6b6dff4a095c648371d9c154a67a84ec.svg";
export { ForwardRef as ReactComponent };